
import filters from "@/mixins/filters";
import { mapActions } from "vuex";

export default {
	mixins: [filters],
	props: {
		offer: Object
	},
	data() {
		return {
			isModalActive: false,
			selected: null
		}
	},
	methods: {
		...mapActions({
			openModal: 'modal/modal-main/openModal'
		}),
		moreInfoComplectation(carInfo) {
			let payload = {
				modal_data: carInfo.equipment_groups[0],
				modal_component: 'modal-complect',
				modal_title: 'Комплектация',
				modal_sub_title: carInfo.name
			}
			this.openModal(payload)
		},
		selectCompetition(value) {

			this.selected !== value ? this.selected = value : this.selected = null
			// this.isModalActive = true
		}
	},
	computed: {
		selectedCompetition() {
			return this.offer.equipment_groups[this.selected]
		}
	},


}
